import {Component} from '@angular/core';

@Component({
  selector: 'app-csv-headers-help',
  standalone: true,
  imports: [],
  templateUrl: './csv-headers-help.component.html',
  styleUrl: './csv-headers-help.component.scss'
})
export class CsvHeadersHelpComponent {

}
